import { ApiEndpointClient } from './resource-client';
export class OrderNotesClient extends ApiEndpointClient {
    constructor(http) {
        super(http, 'valuation-frontend');
    }
    getOrderNotes = async ({ orderId }) => {
        return this.get(`/order/${orderId}/notes`, { response: 'content-type-or-empty' });
    };
    createOrderNote = async ({ orderId, note }) => {
        return this.post(`/order/${orderId}/notes`, { response: 'content-type-or-empty', json: note });
    };
    updateOrderNote = async ({ orderId, noteId, note, }) => {
        return this.put(`/order/${orderId}/notes/${noteId}`, { response: 'content-type-or-empty', json: note });
    };
    deleteOrderNote = async ({ orderId, noteId }) => {
        return this.delete(`/order/${orderId}/notes/${noteId}`, { response: 'content-type-or-empty' });
    };
}
